export const formatApplicationFee = (feeCents: number): string =>
    new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(feeCents / 100)
